import { queryKeys } from '@sshop/api-client';

import { api } from '@/shared/lib/apiClient';
import { defineQuery } from '@/shared/lib/queryFactory';

export const wishlistQuery = () =>
  defineQuery({
    queryKey: queryKeys.wishlist.current(),
    queryFn: ({ signal }) => api.wishlist.get(signal),
    staleTime: 60_000,
  });
